import CommonErrorPage from "./Common/CommonErrorPage";

const Error500 = () => {
  return <CommonErrorPage color="primary" page="500" />;
};

export default Error500;
